import React, { FC } from 'react';
import { TrendItem } from './TrendItem';

export type TrendsWidgetProps = {
    loading: boolean;
    trends: Array<{ title: string; total: number }>;
};

export const TrendsWidget: FC<TrendsWidgetProps> = ({ loading, trends }) => {
    return (
        <div className="grid grid-cols-2 gap-4">
            {trends.map((item, index) => {
                return (
                    <TrendItem
                        isFirst={index === 0}
                        key={index}
                        loading={loading}
                        title={item.title}
                        total={item.total}
                    />
                );
            })}
        </div>
    );
};
